<div id="pbi-container">
    <span class="loadingerror" *ngIf="dashboardLoadError">The dashboard may not display  due to network security at your current location, contact your local support team for assistance</span>
</div>